import { render, staticRenderFns } from "./lockRoomSetting.vue?vue&type=template&id=43542a60&"
import script from "./lockRoomSetting.vue?vue&type=script&lang=js&"
export * from "./lockRoomSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports